import angular from 'angular';

const controllerInfo = {
    module: 'ib-accordion-module',
    inject: [],
    required: []
};

export class ibAccordionController implements ng.IController {
    public model;
    public open = [false, false, false, false];
    public stateAll = false;
    constructor () {

    }


    openCloseAll = (e: any): void => {
        let i;
        this.stateAll = !this.stateAll;

        for (i = 0; i < this.open.length; i++) {
            this.open[i] = this.stateAll;
        }

        e.preventDefault();
    };
}


try {
    ibAccordionController.$inject = controllerInfo.inject;
    angular.module(controllerInfo.module).controller(ibAccordionController.name, ibAccordionController);

} catch (error) {
    const mod = angular.module(controllerInfo.module, controllerInfo.required);
    ibAccordionController.$inject = controllerInfo.inject;
    mod.controller(ibAccordionController.name, ibAccordionController);
}